import { useLocation } from 'react-router-dom'

export function useSearchParams() : [URLSearchParams, undefined] {
  // react-router-dom のバージョンアップによって同名のAPIが追加されるため
  // インタフェースを揃えておくためにタプルを返却している
  return [new URLSearchParams(useLocation().search), undefined]
}